if(! Window.getViewportDimensions ) {
	Window.prototype.getViewportDimensions = function() {
		return {
			width: window.innerWidth || document.body.clientWidth,
			height: window.innerHeight || document.body.clientHeight
		};
	}
}